__turbopack_context__.v({
  "StorylineBlock": "UWVNiG_StorylineBlock",
  "StorylineBlock__content": "UWVNiG_StorylineBlock__content",
  "StorylineBlock__content__placeholder": "UWVNiG_StorylineBlock__content__placeholder",
  "StorylineBlock__content__row": "UWVNiG_StorylineBlock__content__row",
  "StorylineBlock__content__text": "UWVNiG_StorylineBlock__content__text",
  "StorylineBlock__images": "UWVNiG_StorylineBlock__images",
  "StorylineBlock__wrapper": "UWVNiG_StorylineBlock__wrapper",
});
